var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssetlist = function SvgAssetlist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8B572A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75,
    d: "M4.668 5.25h18.667M4.668 16.916h18.667M4.668 11.084h18.667M4.668 22.75h18.667"
  })));
};
export default SvgAssetlist;